import React, { useState } from "react";
import { FiChevronRight, FiChevronDown } from "react-icons/fi";
import PropTypes from "prop-types";

const CollapsibleFollowUp = ({
  commitment,
  details,
  evidence,
  confidence,
  scheduled,
  date,
  purpose,
}) => {
  const [expanded, setExpanded] = useState(false);

  const hasCommitment = commitment && String(commitment).trim().length > 0;
  const hasDetails = details && String(details).trim().length > 0;
  const hasEvidence = evidence && String(evidence).trim().length > 0;
  const hasConfidence =
    confidence && (String(confidence).trim().length > 0 || confidence === 0);
  const hasScheduled = scheduled && String(scheduled).trim().length > 0;
  const hasDate = date && String(date).trim().length > 0;
  const hasPurpose = purpose && String(purpose).trim().length > 0;

  if (
    !hasCommitment &&
    !hasDetails &&
    !hasEvidence &&
    !hasConfidence &&
    !hasScheduled &&
    !hasDate &&
    !hasPurpose
  ) {
    return null;
  }

  const toggle = () => setExpanded((prev) => !prev);

  const renderSection = (title, content) => (
    <div style={{ marginBottom: "12px" }}>
      <div className="collapsible-details-section-title">{title}</div>
      {typeof content === "string" ? (
        <div
          className="collapsible-details-text"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      ) : (
        <div className="collapsible-details-text">{content}</div>
      )}
    </div>
  );

  return (
    <div className="collapsible-details">
      <div className="collapsible-details-header" onClick={toggle}>
        {expanded ? <FiChevronDown /> : <FiChevronRight />} Follow-Up Details
      </div>
      {expanded && (
        <div className="collapsible-details-content">
          {hasCommitment && renderSection("Commitment", commitment)}
          {hasDetails && renderSection("Details", details)}
          {hasEvidence && renderSection("Evidence", evidence)}
          {hasConfidence && renderSection("Confidence", confidence)}
          {hasScheduled && renderSection("Scheduled", scheduled)}
          {hasDate && renderSection("Date", date)}
          {hasPurpose && renderSection("Purpose", purpose)}
        </div>
      )}
    </div>
  );
};

export default CollapsibleFollowUp;
